import { useEffect, useState } from "react";

type Theme = "light" | "dark";
type Density = "comfortable" | "compact";
type Context = "field" | "wall" | "edge";

/** Runtime data-theme / data-density / data-context switching (UX-004). Self-contained. */
export function ThemeControls() {
  const [theme, setTheme] = useState<Theme>("light");
  const [density, setDensity] = useState<Density>("comfortable");
  const [context, setContext] = useState<Context>("field");

  useEffect(() => {
    const root = document.documentElement;
    root.dataset.theme = theme;
    root.dataset.density = density;
    root.dataset.context = context;
  }, [theme, density, context]);

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select label="Theme" value={theme} options={["light", "dark"]} onChange={setTheme} />
      <Select
        label="Density"
        value={density}
        options={["comfortable", "compact"]}
        onChange={setDensity}
      />
      <Select
        label="Context"
        value={context}
        options={["field", "wall", "edge"]}
        onChange={setContext}
      />
    </div>
  );
}

function Select<T extends string>({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: T;
  options: readonly T[];
  onChange: (v: T) => void;
}) {
  return (
    <label className="flex items-center gap-1 text-sm">
      <span className="text-text-muted">{label}</span>
      <select
        className="rounded border border-border bg-surface px-1 py-0.5 text-text focus:outline focus:outline-2 focus:outline-accent"
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
      >
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </label>
  );
}
